// components/Dashboard/alerts.tsx
import React from 'react';
import { NotificationProps } from '../../type';
import { useTranslate } from "../../hooks/LanguageProvider";
import { Table } from 'react-bootstrap';

const Notification: React.FC<NotificationProps> = ({ Notifications }) => {

  const { translate } = useTranslate();
  return (
    <>
      {Notifications.length > 0 ? (
        <Table style={{ width: '100%', tableLayout: 'fixed' }}>
          <thead
            className="bg-white text-uppercase"
            style={{
              position: 'sticky',
              top: 0,
              zIndex: 1,
              backgroundColor: 'white',
              width: '100%',
              display: 'table',
            }}
          >
            <tr className="ligth ligth-data">
              <th>{translate("Type")}</th>
              <th>{translate("Message")}</th>
              <th>{translate("Date")}</th>
            </tr>
          </thead>
          <tbody
            style={{
              display: 'block',
              maxHeight: '400px',
              overflowY: 'auto',
              width: '100%',
              height: 'auto',
            }}
          >
            {Notifications.map((notification: any) => (
              <tr key={notification.id_notification} style={{ width: '100%',display: 'table' }}>
                <td>{notification.type}</td>
                <td>{notification.message}</td>
                <td>{new Date(notification.timestamp).toLocaleTimeString()}</td>
              </tr>
            ))}
          </tbody>
        </Table>


      ) : (
        <p>Aucune notification.</p>
      )}
    </>
  );

};

export default Notification;
